import React, { useState, useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import Cookies from "js-cookie";
import Modal from "react-modal";
import "./CookiePopup.scss";
import { isMobile } from "react-device-detect";
import {
  cookieAlertModal,
  smallModalStylesMobile,
} from "../../utils/modalStyles/ModalMainStyle";

const CookiesContainer = () => {
  const [cookieStatus, setCookieStatus] = useState(null); // null, true (accepted), false (rejected)
  const [modalOpen, setModalOpen] = useState(false);

  // Preferences state example (you can customize categories)
  const [preferences, setPreferences] = useState({
    essential: true, // always true, can't be disabled
    analytics: false,
    marketing: false,
  });

  // Load saved preferences from cookies on mount
  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (consent === "true") setCookieStatus(true);
    else if (consent === "false") setCookieStatus(false);

    // Load preferences if saved
    const savedPrefs = Cookies.get("cookiePreferences");
    if (savedPrefs) setPreferences(JSON.parse(savedPrefs));
  }, []);

  // Accept all cookies
  const handleAccept = () => {
    setCookieStatus(true);
    Cookies.set("cookieConsent", "true", { sameSite: "strict", secure: true });
    // Save all preferences as accepted
    setPreferences({
      essential: true,
      analytics: true,
      marketing: true,
    });
    Cookies.set(
      "cookiePreferences",
      JSON.stringify({ essential: true, analytics: true, marketing: true }),
      { sameSite: "strict", secure: true }
    );
  };

  // Reject all optional cookies
  const handleReject = () => {
    setCookieStatus(false);
    Cookies.set("cookieConsent", "false", { sameSite: "strict", secure: true });
    // Essential cookies still true, others false
    setPreferences({
      essential: true,
      analytics: false,
      marketing: false,
    });
    Cookies.set(
      "cookiePreferences",
      JSON.stringify({ essential: true, analytics: false, marketing: false }),
      { sameSite: "strict", secure: true }
    );
  };

  // Open modal to manage preferences
  const handleManage = () => {
    setModalOpen(true);
  };

  // Close preferences modal and save choices
  const closeModal = () => {
    setModalOpen(false);
    Cookies.set("cookieConsent", "true", { sameSite: "strict", secure: true });
    Cookies.set("cookiePreferences", JSON.stringify(preferences), {
      sameSite: "strict",
      secure: true,
    });
    setCookieStatus(true);
  };
  const handleLearnMore = () => {
    window.open(
      "https://www.merago.com/privacy-policy",
      "_blank",
      "noopener,noreferrer"
    );
  };

  // Toggle individual preferences except essential (always true)
  const togglePreference = (key) => {
    if (key === "essential") return;
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  let cookieBtns = (
    <div className="btm__btns">
      <button onClick={handleLearnMore} className="learnMore">
        Learn More
      </button>
      {/* <button className="learnMore deny__button" onClick={handleDenyClick}>
        Deny All
      </button> */}
    </div>
  );
  

  // Decide visibility of cookie consent popup
  const visible =
    cookieStatus === true || cookieStatus === false ? "hidden" : "show";

  return (
    <>
      <div className="cookies_Popup">
        {/* <CookieConsent
          overlay
          containerClasses="cookies"
          buttonClasses="btn_accept"
          location="bottom"
          buttonText="Accept All"
          hideOnAccept={false}
          visible={visible}
          onAccept={handleAccept}
          cookieName="cookieConsent"
          cookieSecurity={true}
          sameSite="strict"
          enableDeclineButton={false} // We will use custom reject button
          debug={false}
        >
          <div style={{ fontSize: "0.9em" }}>
            We use{" "}
            <span
              style={{ color: "#66c0ff", cursor: "pointer" }}
              onClick={handleManage}
            >
              cookies
            </span>{" "}
            to enhance your browsing experience and analyze our traffic. You
            can consent by clicking "Accept All" or reject all optional cookies
            by clicking "Reject All".
          </div>
          <div className="btm__btns" style={{ marginTop: "10px" }}>
            <button onClick={handleManage} className="managePrefsBtn">
              Manage Preferences
            </button>
            <button onClick={handleReject} className="rejectBtn">
              Reject All
            </button>
          </div>
        </CookieConsent> */}

      <CookieConsent
  overlay
  containerClasses="cookies"
  location="bottom"
  hideOnAccept={false}
  visible={visible}
  cookieName="cookieConsent"
  cookieSecurity={true}
  sameSite="strict"
  enableDeclineButton={false}
  buttonText=""
  onAccept={() => {}}
  
>
  
  <div className="cookie-inner">
    <div className="cookie-text">
      <strong>We use cookies</strong> to enhance your browsing experience and
      analyze our traffic. You can consent by clicking "Accept All" or manage your cookies.
    </div>

    <div className="cookie-actions">
      {/* <button onClick={handleAccept}>Accept All</button>
      <button onClick={handleReject}>Reject All</button> */}
      <button onClick={handleAccept} className="accept-btn">Accept All</button>
      {/* <button onClick={handleReject} className="reject-btn">Reject All</button> */}
      <button onClick={handleManage} className="managePrefsBtn">
        Manage Preferences
      </button>
    </div>
     
  </div>

</CookieConsent>
      </div>

      {/* Preferences Modal */}
      {/* <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        style={{ content: { maxWidth: "400px", margin: "auto" } }}
        ariaHideApp={false}
      >
        <h3>Manage Cookie Preferences</h3>
        <p>
          These cookies are used to improve your experience. You can choose
          which to enable.
        </p>
        <form>
          <label>
            <input
              type="checkbox"
              checked={preferences.essential}
              disabled
              readOnly
            />{" "}
            Essential Cookies (Required)
          </label>
          <br />
          <label>
            <input
              type="checkbox"
              checked={preferences.analytics}
              onChange={() => togglePreference("analytics")}
            />{" "}
            Analytics Cookies
          </label>
          <br />
          <label>
            <input
              type="checkbox"
              checked={preferences.marketing}
              onChange={() => togglePreference("marketing")}
            />{" "}
            Marketing Cookies
          </label>
          <br />
          <button
            type="button"
            onClick={closeModal}
            style={{ marginTop: "15px" }}
          >
            Save Preferences
          </button>
        </form>
      </Modal> */}

 <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        style={!isMobile ? cookieAlertModal : smallModalStylesMobile}
        ariaHideApp={false}
      >
        <div className="html__title__wrapper">
          <div className="html__title flex__modalTitle">
            <h4>Cookie Alert</h4>
          </div>
        </div>
        <div className="modal__body cookie__popup__body">
          <h4>
            These cookies are necessary for the website to function and cannot
            be switched off in our systems. These are used for storing and
            functioning of the following features:
          </h4>
          <br />
          <form>
          <label>
            <input
              type="checkbox"
              checked={preferences.essential}
              disabled
              readOnly
            />{" "}
            Essential Cookies (Required)
          </label>
          <br />
          
          <label>
            <input
              type="checkbox"
              checked={preferences.analytics}
              onChange={() => togglePreference("analytics")}
            />{" "}
            Analytics Cookies
          </label>
          <br />
          <label>
            <input
              type="checkbox"
              checked={preferences.marketing}
              onChange={() => togglePreference("marketing")}
            />{" "}
            Marketing Cookies
          </label>
          <br />
          {/* <button
            type="button"
            onClick={closeModal}
            style={{ marginTop: "15px" }}
          >
            Save Preferences
          </button> */}
        </form>
          <button onClick={closeModal}>OK</button>
        </div>
      </Modal>

    </>
  );
};

export default CookiesContainer

